import { useOmnibusDirective } from '@bluheadless/ui-logic/src/hooks/omnibus/useOmnibusDirective'
import { FormattedMessage } from 'react-intl'
import Typography from '../../atoms/typography/typography'
import { PriceRaw } from '../price'
import SkeletonList from '../skeleton/list/skeleton-list'
import { OmnibusPriceWrapper } from './omnibus-price.styled'

const OmnibusPrice = ({ className, priceProps }) => {
	const { price, loading } = useOmnibusDirective()

	if (!price && !loading) return null

	return (
		<OmnibusPriceWrapper className={className}>
			{!price && loading ? (
				<SkeletonList height={18} rows={1} />
			) : (
				<>
					<Typography variant="caption" color="grey.main" component="span">
						<FormattedMessage id="omnibus_price" />
					</Typography>
					<PriceRaw className="omnibus-price" {...priceProps} amount={price} />
				</>
			)}
		</OmnibusPriceWrapper>
	)
}

export default OmnibusPrice
